import { Command as CommandPrimitive } from "cmdk";
import { type ComponentProps } from "react";

import { cn } from "../../utils";
import { MenuItem, menuItemContent, type MenuItemContentProps, type MenuItemProps } from "../menu-item";

export type CommandItemProps = Omit<ComponentProps<typeof CommandPrimitive.Item>, "children" | "asChild"> &
  Pick<MenuItemProps, "leading" | "shortcut" | "trailing" | "hasSubmenu" | "link"> &
  MenuItemContentProps;

const Item = (props: CommandItemProps) => {
  const { leading, ref, className, shortcut, trailing, hasSubmenu, link, label, description, children, ...itemProps } =
    props;

  return (
    <CommandPrimitive.Item ref={ref} {...itemProps} asChild>
      <MenuItem
        leading={leading}
        {...menuItemContent(label, description, children)}
        shortcut={shortcut}
        trailing={trailing}
        hasSubmenu={hasSubmenu}
        link={link}
        // Keeps Tab in the search input: cmdk moves through the rows with the arrow keys.
        tabIndex={link ? -1 : undefined}
        // Icons rendered in the children take a leading icon's colour.
        className={cn("[&_svg]:text-neutral-50", className)}
      />
    </CommandPrimitive.Item>
  );
};

Item.displayName = CommandPrimitive.Item.displayName;

export default Item;
